import React from "react";
import AsyncPagedSelect from "../../apps/ClassroomApp/components/AsyncPagedSelect.jsx";
import { getCrmReportOptions } from "../../../services/CrmReportService";
import "./crm-filters.css";

/* The CRM reports' filters: From, To, Batch status, Course, Trainer and,
   on the students report, Student status. Course and Trainer are picked
   from the batches the reports read (GET /crm-reports/options); the name
   picked rides along beside its id, so a second copy of the fields (the
   popup's) can show it. Drawn on the report page (applied with its
   Apply button) and in a card's list popup (applied as they change);
   the API applies them (crmreport.service.js filtersOf). `idPrefix`
   keeps the two sets of ids apart when the popup sits over the page. */

// Ongoing batches until the filters say otherwise -- the API's default too.
export const NO_FILTERS = {
  status: "ongoing",
  from: "",
  to: "",
  studentStatus: "all",
  courseId: "",
  trainerId: "",
  courseName: "",
  trainerName: "",
};
// The filters themselves; the names are only for showing.
export const FILTER_FIELDS = ["status", "from", "to", "studentStatus", "courseId", "trainerId"];

// Server-paged: the next page loads as the menu is scrolled to its end.
const fetchCourses = (page, term) => getCrmReportOptions("course", page, term, 20);
const fetchTrainers = (page, term) => getCrmReportOptions("trainer", page, term, 20);
const toOption = (o) => ({ value: o.id, label: o.name });

const CrmFilterFields = ({ kind, value, onChange, idPrefix }) => {
  const set = (field, v) => onChange({ ...value, [field]: v });
  const id = (name) => `${idPrefix}-${kind}-${name}`;
  const pick = (field, nameField) => (v, option) => onChange({ ...value, [field]: v, [nameField]: option ? option.label : "" });
  // The picked one's name, shown before any page has loaded.
  const seed = (v, name) => (v ? { value: v, label: name || "…" } : null);

  return (
    <>
      <div className="pg-field">
        <label className="pg-label" htmlFor={id("from")}>
          From
        </label>
        <input
          id={id("from")}
          type="date"
          className="pg-input"
          value={value.from}
          max={value.to || undefined}
          onChange={(e) => set("from", e.target.value)}
        />
      </div>
      <div className="pg-field">
        <label className="pg-label" htmlFor={id("to")}>
          To
        </label>
        <input
          id={id("to")}
          type="date"
          className="pg-input"
          value={value.to}
          min={value.from || undefined}
          onChange={(e) => set("to", e.target.value)}
        />
      </div>
      <div className="pg-field">
        <label className="pg-label" htmlFor={id("status")}>
          Batch status
        </label>
        <select id={id("status")} className="pg-select" value={value.status} onChange={(e) => set("status", e.target.value)}>
          <option value="ongoing">Ongoing</option>
          <option value="completed">Completed</option>
          <option value="all">All</option>
        </select>
      </div>
      <div className="pg-field crm-pick">
        <span className="pg-label" id={id("course")}>
          Course
        </span>
        <AsyncPagedSelect
          labelId={id("course")}
          value={value.courseId}
          onChange={pick("courseId", "courseName")}
          fetchPage={fetchCourses}
          toOption={toOption}
          initialOption={seed(value.courseId, value.courseName)}
          placeholder="All courses"
        />
      </div>
      <div className="pg-field crm-pick">
        <span className="pg-label" id={id("trainer")}>
          Trainer
        </span>
        <AsyncPagedSelect
          labelId={id("trainer")}
          value={value.trainerId}
          onChange={pick("trainerId", "trainerName")}
          fetchPage={fetchTrainers}
          toOption={toOption}
          initialOption={seed(value.trainerId, value.trainerName)}
          placeholder="All trainers"
        />
      </div>
      {kind === "students" && (
        <div className="pg-field">
          <label className="pg-label" htmlFor={id("active")}>
            Student status
          </label>
          <select
            id={id("active")}
            className="pg-select"
            value={value.studentStatus}
            onChange={(e) => set("studentStatus", e.target.value)}
          >
            <option value="all">All</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      )}
    </>
  );
};

export default CrmFilterFields;
